module.exports = __webpack_public_path__ + "img/1920_island_intro_img2.17489f6a.png";